module.exports = __webpack_public_path__ + "static/media/sun.2110aa2c.svg";